/**
 * LOS TIPOS DE NEGOCIO Y LOS PLANES, DESDE LA BASE (TIPO-NEGOCIO-CANON-T1, punto 3 de #14907).
 *
 * DE DONDE SALE. GET /api/businesses/config devolvia listas vacias con 200 (leia
 * dos CHECK que no existen), asi que el panel tenia la lista escrita a mano en
 * CUATRO sitios, y no coincidian: la ficha y la lista de negocios con 12 tipos,
 * el wizard de negocio nuevo con 7, y el chat del enlace publico ofreciendo un
 * plan Premium que no existe. Argy-A llevo la canon a la base (nexo_catalogs.
 * tipos_negocio y nexo_catalogs.planes, api PR 263) y el config la sirve.
 *
 * EL CONTRATO (api PR 263, head 8e92fca), sin credencial:
 *   200 {businessTypes:[nombre], plans:[nombre], planesDelEnlace:[nombre],
 *        tipos:[{codigo, nombreVisible, modoDesktop, modoInferido}],
 *        planes:[{planCode, nombreVisible, seOfreceEnEnlace}]}
 *   500 {message, code: CATALOGO_VACIO | CATALOGO_NO_DISPONIBLE}
 *
 * LA REGLA: NINGUNA LISTA A MANO. Si el catalogo no se puede leer, la vista lo
 * dice y deja solo el valor que el negocio ya tiene. Una lista vieja escrita en
 * el panel es lo que dejo cuatro versiones distintas de la misma cosa.
 *
 * Sin DOM: lo prueba scripts/check-catalogo-negocio.mjs.
 */

export const MENSAJE_SIN_CATALOGO =
  'No se pudo leer la lista de tipos de negocio y planes. Se deja solo el valor que ya tiene; reintenta en un momento.';

const nombres = (lista, clave, claveP) => (Array.isArray(lista) ? lista : [])
  .map((x) => (typeof x === 'string' ? x : (x && (x[clave] !== undefined ? x[clave] : x[claveP]))))
  .filter((x) => typeof x === 'string' && x.trim() !== '');

/**
 * Lee el config. Recibe {ok, data} (el CrudResult de ApiBase, o lo que arma el
 * chat publico con fetch). Nunca lanza.
 * estado: 'ok' | 'vacio' (el 200 con listas vacias de antes) | 'no-disponible'
 */
export function leerCatalogo(resultado) {
  if (!resultado || resultado.ok === false) {
    return { tipos: [], planes: [], planesDelEnlace: [], consentimiento: null, facturacionElectronicaOfrecida: false, estado: 'no-disponible' };
  }
  let d = resultado.data !== undefined ? resultado.data : resultado;
  if (d && d.businessTypes === undefined && d.tipos === undefined && d.data) d = d.data;
  d = d || {};

  const tipos = nombres(d.businessTypes, '', '').length ? nombres(d.businessTypes, '', '') : nombres(d.tipos, 'nombreVisible', 'NombreVisible');
  const planes = nombres(d.plans, '', '').length ? nombres(d.plans, '', '') : nombres(d.planes, 'nombreVisible', 'NombreVisible');

  let delEnlace = nombres(d.planesDelEnlace, '', '');
  if (!delEnlace.length && Array.isArray(d.planes)) {
    delEnlace = d.planes
      .filter((p) => p && (p.seOfreceEnEnlace === true || p.SeOfreceEnEnlace === true))
      .map((p) => p.nombreVisible || p.NombreVisible)
      .filter(Boolean);
  }
  return {
    tipos, planes, planesDelEnlace: delEnlace,
    // CONSENT-UN-SOLO-SI-T1: el bloque del si y del no viaja en el mismo config.
    // Se entrega tal cual; lo interpreta application/onboarding/consentimiento.js.
    consentimiento: d.consentimiento || d.Consentimiento || null,
    // ONB-DIAN-PARAMETRO-T1: la llave va SUELTA en la raiz del config (A #15419).
    // Solo un true la enciende: si no llega (API vieja) el servicio no se ofrece.
    facturacionElectronicaOfrecida: d.facturacion_electronica_ofrecida === true || d.facturacionElectronicaOfrecida === true,
    estado: tipos.length && planes.length ? 'ok' : 'vacio'
  };
}

/**
 * Las opciones de un select de edicion. Si el negocio tiene un valor que no
 * esta en la lista (uno de antes de la canon, o el catalogo no se pudo leer),
 * se conserva: guardar la ficha no debe cambiar un dato que nadie toco.
 */
export function opcionesConValorActual(lista, actual) {
  const out = [];
  for (const x of lista || []) if (!out.includes(x)) out.push(x);
  const a = String(actual === null || actual === undefined ? '' : actual).trim();
  if (a && !out.includes(a)) out.push(a);
  return out;
}

function unirConO(lista) {
  const l = (lista || []).filter(Boolean);
  if (!l.length) return '';
  if (l.length === 1) return l[0];
  return l.slice(0, -1).join(', ') + ' o ' + l[l.length - 1];
}

/** La pregunta del plan en el chat publico: solo los planes que se ofrecen en el enlace. */
export function preguntaDelPlan(planesDelEnlace) {
  const lista = unirConO(planesDelEnlace);
  return lista
    ? '¿Qué plan te interesa: ' + lista + '? (si no sabes, escribe "me ayudan a elegir")'
    : '¿Qué plan te interesa? (si no sabes, escribe "me ayudan a elegir")';
}

/** La pregunta del tipo, con ejemplos que SI estan en la canon. */
export function preguntaDelTipo(tipos) {
  const ejemplos = (tipos || []).filter((t) => t && t !== 'Otro').slice(0, 4).map((t) => t.toLocaleLowerCase('es'));
  return ejemplos.length
    ? '¿Qué tipo de negocio es? (ej: ' + ejemplos.join(', ') + '…)'
    : '¿Qué tipo de negocio es?';
}
